var CNotificationLists = Backbone.Collection.extend({
    url: '/ajax/notification_list/get_lists.php',

    comparator: 'notificationname',

    model: CNotificationList,

    parse: function(data)
    {
        return _.values(data.data);
    },

    getAllRecipients: function()
    {
        return _.uniq(_.reduce(this.models, function(memo, item) {
            return _.union(memo, item.get('recipients'));
        }, []));
    },

    isValidModel: function(model)
    {
        var matchesByName = this.filter(function(item) {
            return model.get('notificationname').toLowerCase() === item.get('notificationname').toLowerCase() && model.id !== item.id;
        });

        if (matchesByName.length > 0)
        {
            this.modelValidationError = 'Name is already used by another notification list.';
            return false;
        }

        this.modelValidationError = '';
        return true;
    },

    /**
     * @param objTargetModel
     */
    setDefaultList: function(objTargetModel)
    {
        this.models.forEach(function(objModel)
        {
            if (objModel.id !== objTargetModel.id)
            {
                objModel.set('defaultlist', false);
            }
        });
    }
});
